import React from "react";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import { useFormikContext } from "formik";
import { selectCurrentProductId } from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import { selectAllFormSettings } from "../../../../redux/slices/formSettingsSlice";
import ProductHeader from "./ProductHeader";

const ConnectedProductHeader = () => {
    const { values } = useFormikContext();
    const currentProductId = useSelector(selectCurrentProductId);
    const products = useSelector(selectAllProducts);

    const product = findProductFromProductId(currentProductId, products);

    const { Product_Id, Field_Data_Id } = values;
    const {
        price_fixed = 0,
        price_low = 0,
        price_high = 0,
        title = "",
    } = product;

    const formSettings = useSelector(selectAllFormSettings);
    const { currency } = formSettings;

    // Field_Data_Id and !price_fixed then once all attributes
    // have been selected, use field_Data_Id to replace productPrice with
    // specific product price. To do this Field_Data_Id must be updated before the submit

    const currentProduct =
        Product_Id && Field_Data_Id
            ? findProductFromProductId(Product_Id, products).fieldData[
                  Field_Data_Id
              ]
            : {};

    const pricePerAttributeSelection = currentProduct
        ? currentProduct.cost
        : undefined;

    const priceFixedFormattedPrice =
        !price_fixed && Field_Data_Id && pricePerAttributeSelection
            ? currencyString(pricePerAttributeSelection, currency)
            : currencyString(price_fixed, currency);

    const formattedPrice =
        !price_fixed && !Field_Data_Id
            ? currencyString(price_low, currency)
            : priceFixedFormattedPrice;

    const priceRangeEqual =
        formattedPrice === currencyString(price_high, currency);

    const productPrice =
        !price_fixed && !Field_Data_Id && !priceRangeEqual
            ? `${formattedPrice}-${price_high} ea.`
            : formattedPrice;

    const formattedCost = productPrice;

    const productHeaderProps = {
        formattedCost,
        title,
    };
    return <ProductHeader {...productHeaderProps} />;
};

export default ConnectedProductHeader;
